/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  SpendRuleTargetCondition,
  SpendRuleTargetCondition$Outbound,
  SpendRuleTargetCondition$outboundSchema,
} from "./spendruletargetcondition.js";

/**
 * Rule action: flag or block.
 */
export const CreateSpendRuleRequestBodyAction = {
  Flag: "flag",
  Block: "block",
} as const;
/**
 * Rule action: flag or block.
 */
export type CreateSpendRuleRequestBodyAction = ClosedEnum<
  typeof CreateSpendRuleRequestBodyAction
>;

/**
 * UTC calendar window the budget covers.
 */
export const WindowKind = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
} as const;
/**
 * UTC calendar window the budget covers.
 */
export type WindowKind = ClosedEnum<typeof WindowKind>;

export type CreateSpendRuleRequestBody = {
  /**
   * Rule action: flag or block.
   */
  action?: CreateSpendRuleRequestBodyAction | undefined;
  /**
   * Optional description of what the rule covers.
   */
  description?: string | undefined;
  /**
   * Whether the rule is active.
   */
  enabled?: boolean | undefined;
  /**
   * Per-person budget in USD for one window.
   */
  limitUsd: number;
  /**
   * The rule name.
   */
  name: string;
  target: SpendRuleTargetCondition;
  /**
   * Percentage of the limit at which a warning event is emitted.
   */
  warnAtPct?: number | undefined;
  /**
   * UTC calendar window the budget covers.
   */
  windowKind: WindowKind;
};

/** @internal */
export const CreateSpendRuleRequestBodyAction$outboundSchema: z.ZodMiniEnum<
  typeof CreateSpendRuleRequestBodyAction
> = z.enum(CreateSpendRuleRequestBodyAction);

/** @internal */
export const WindowKind$outboundSchema: z.ZodMiniEnum<typeof WindowKind> = z
  .enum(WindowKind);

/** @internal */
export type CreateSpendRuleRequestBody$Outbound = {
  action: string;
  description: string;
  enabled: boolean;
  limit_usd: number;
  name: string;
  target: SpendRuleTargetCondition$Outbound;
  warn_at_pct: number;
  window_kind: string;
};

/** @internal */
export const CreateSpendRuleRequestBody$outboundSchema: z.ZodMiniType<
  CreateSpendRuleRequestBody$Outbound,
  CreateSpendRuleRequestBody
> = z.pipe(
  z.object({
    action: z._default(CreateSpendRuleRequestBodyAction$outboundSchema, "flag"),
    description: z._default(z.string(), ""),
    enabled: z._default(z.boolean(), true),
    limitUsd: z.number(),
    name: z.string(),
    target: SpendRuleTargetCondition$outboundSchema,
    warnAtPct: z._default(z.int(), 80),
    windowKind: WindowKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      limitUsd: "limit_usd",
      warnAtPct: "warn_at_pct",
      windowKind: "window_kind",
    });
  }),
);

export function createSpendRuleRequestBodyToJSON(
  createSpendRuleRequestBody: CreateSpendRuleRequestBody,
): string {
  return JSON.stringify(
    CreateSpendRuleRequestBody$outboundSchema.parse(createSpendRuleRequestBody),
  );
}
